
{
  "labels": {
    "title": "Title",
    "options": "Options",
    "required": "Required"
  }
}
